import { CheckmarkThin, CloseCrossThinSvg, useBEM } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { REGISTRATION_SUGGESTIONS_TRANSLATION_NAMESPACE, ResponseStatus } from '../RegistrationSuggestionsPage';

export const RequestResultForSuggestion = ({ requestResult }: { requestResult: ResponseStatus }) => {
  const bemClasses = useBEM('RegistrationSuggestionsPage');
  const { t } = useTranslation(REGISTRATION_SUGGESTIONS_TRANSLATION_NAMESPACE);
  const requestWasSuccessful = ['isSuper', 'success'].includes(requestResult);

  return (
    <div
      className={bemClasses({
        element: 'request-response-container',
        modifier: requestResult,
      })}
    >
      {requestWasSuccessful ? <CheckmarkThin /> : <CloseCrossThinSvg />}
      <p
        className={bemClasses({
          element: 'request-response-text',
        })}
      >
        {t(requestResult)}
      </p>
    </div>
  );
};
